import React, { useState, useEffect } from "react";
import { Box, Select, MenuItem, Checkbox } from "@material-ui/core";
import {
  useStyles,
} from "examsbook-react-sdk/custom-hooks";
import i18n from "examsbook-react-sdk/translations";
import { useDispatch, useSelector } from "react-redux";
import { languageAction } from 'examsbook-react-sdk/actions/languageAction';
import { updateUser } from "examsbook-react-sdk/actions/getUser";

export const LanguageSelect = ({ isInline = false }) => {
  const defaultLanguage = useSelector((state) => {
    if (isInline) {
      const lang = state.user?.language || "en";
      return lang === "en" || lang === "hn" ? lang : "en";
    }
    return state.getLanguaggeReducer.lang || "en";
  });

  const [language, setLanguage] = useState(defaultLanguage);

  useEffect(() => {
    setLanguage(defaultLanguage);
  }, [defaultLanguage]);
  
  const user = useSelector((state) => state.user);
  const userId = user?.user?._id ? user?.user?._id : user?._id;
  const dispatch = useDispatch();

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    setLanguage(selectedLanguage);

    // Always update localStorage and i18n
    i18n.changeLanguage(selectedLanguage);
    dispatch(languageAction(selectedLanguage));
    // Only update user profile if user is authenticated
    if (userId) {
      dispatch(updateUser(userId, { language: selectedLanguage }));
    }
  };

  const styles = {
      languageSelect: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: isInline ? "static" : "absolute",
          right: isInline ? "auto" : "2rem",
          top: isInline ? "auto" : "2rem",
          zIndex: isInline ? "auto" : 10,

          backgroundColor: "#ffffff",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          padding: "6px 10px",
          boxShadow: isInline
        ? "none"
        : "0 4px 12px rgba(0,0,0,0.08)",
          "& .Mui-focused": {
              borderBottom: "none !important",
          },
          "& .MuiSelect-root": {
              width: "90px",
              textAlign: "left",
              padding: "7px 35px 7px 7px",
              fontSize: "16px",
              fontWeight: 500,
          },

          "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
          },

          "@media only screen and (max-width: 767px)": {
              right: "0.75rem",
              top: "0.75rem",

              "& .MuiSelect-root": {
                  padding: "0 17px 3px 0",
                  fontSize: "14px",
              },
          },
      },
  };


  const classes = useStyles(styles)();

  return (
      <Box className={classes.languageSelect}>
          <Select
              id="language-select"
              value={language}
              onChange={handleLanguageChange}
              variant="outlined"
              size="small"
              renderValue={(value) => (value === "en" ? "English" : "हिंदी")}
          >
              <MenuItem value="en">
                  English
                  <Checkbox
                      checked={language === "en"}
                      color="primary"
                      style={{ marginLeft: "auto" }}
                  />
              </MenuItem>
              <MenuItem value="hn">
                  हिंदी
                  <Checkbox
                      checked={language === "hn"}
                      color="primary"
                      style={{ marginLeft: "auto" }}
                  />
              </MenuItem>
          </Select>
      </Box>
  );
};